define('vspot-angular/services/comment-service',[], function () {
    'use strict';

    return ['resources.Comment', 'resources.OrgComment', function (Comment, OrgComment) {

        return {
            query: function(activityId, jobId) {
                var commentResult = Comment.query({
                    activity_id:        activityId, // Used in the auth phase
                    selected_activity:  activityId, // Duplicate, but used in the comment query phase
                    job_id:             jobId
                });

                commentResult.$promise.then(function(result) {
                    // Weirdly, the JSON is returning 2 ID's as text, instead of numbers. We want them as numbers for consistencey
                    if( result && result.data && result.data.length > 0 ) {
                        for( var c=0, cLen=result.data.length; c<cLen; c++ ) {
                            result.data[c].organizer_id = parseInt(result.data[c].organizer_id, 10);
                            result.data[c].volunteer_id = parseInt(result.data[c].volunteer_id, 10);
                        }
                    }
                });

                return commentResult;
            },

            orgQuery: function(activityId, jobId) {     // Like query, but always returns commentor's names
                return OrgComment.query({
                    activity_id:        activityId, // Used in the auth phase
                    selected_activity:  activityId, // Duplicate, but used in the comment query phase
                    job_id:             jobId,
                });
            },

            save: function(activityId, accessKey, jobId, comment) {
                return Comment.save({
                    accesskey:          accessKey,
                    activity_id:        activityId, // Used in the auth phase
                    selected_activity:  activityId, // Duplicate, but used in the comment query phase
                    job_id:             jobId,
                    text:               comment,
                    viewable:           true // Hard coding because viewable is how we 'delete' comments, so creating implies making it viewable
                });
            },

            update: function(commentId, activityId, accessKey, jobId, comment) {
                return Comment.update({
                    id:                 commentId, // Id of the comment to update
                    accesskey:          accessKey,
                    activity_id:        activityId, // Used in the auth phase
                    selected_activity:  activityId, // Duplicate, but used in the comment query phase
                    job_id:             jobId,
                    text:               comment
                });
            },

            delete: function(activityId, accessKey, id) {
                return Comment.delete({
                    accesskey:          accessKey,
                    activity_id:        activityId, // Used in the auth phase
                    selected_activity:  activityId, // Duplicate, but used in the comment query phase
                    id:                 id
                });
            }
        };
    }];
});

